import { Fragment } from 'react';
import { IconButton, useEventCallback } from '@mui/material';
import { createSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { ActionProps } from 'shell/view-models/actions-props';
import { Edit } from '@mui/icons-material';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { __PERSON_API_URL__ } from 'shell/constants/environment';
import { FiltersFormPerson } from 'shell/view-models/search-anpr';
import { useFilterTable } from 'shell/hooks/use-filter-table';
import { DefaultFilterTable } from 'shell/constants/person-search';

const ActionsList = ({ cell, filterPersonForm }: ActionProps): React.ReactElement => {
  const navigate = useNavigate();

  const personFilterTable = useFilterTable<FiltersFormPerson>();
  const getPerson = useHttpClient(
    `${__PERSON_API_URL__}/ricerca-persona/rilascio-permesso-di-soggiorno`,
    {
      options: {
        loading: true,
        errorCatching: true,
        method: 'POST',
      },
    }
  );

  const onEditPress = useEventCallback(() => {
    return new Promise((resolve) => {
      (
        getPerson({
          data: {
            criteriRicerca: {
              idSchedaSoggettoANPR: cell?.anpr,
              codiceFiscale: cell?.fiscalCode || undefined,
            },
            datiRichiesta: {
              ricercaNazionale:
                filterPersonForm?.commonSearch?.isNationalResearch ||
                filterPersonForm?.subjectData?.isNationalResearch
                  ? '1'
                  : '0',
            },
          },
        }) as ResponsePromise<void>
      ).then(() => {
        personFilterTable.setValues(DefaultFilterTable);

        navigate({
          pathname: '/sportello/rilascioPDS/modifica',
          search: `?${createSearchParams({
            idSchedaSoggettoANPR: cell?.anpr || '',
          })}`,
        });
        resolve(cell);
      });
    });
  });

  return (
    <Fragment>
      <IconButton
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onEditPress();
        }}
        aria-label="Visualizza elemento"
        aria-haspopup="true"
        style={{
          padding: '4px',
        }}
      >
        <Edit />
      </IconButton>
    </Fragment>
  );
};

ActionsList.displayName = 'Action list Document - residency permit page component';

export default ActionsList;
